import { useQuery } from '@tanstack/react-query'
import { getArchivedMeetings } from '../api/meetingApi'

/** Arşivlenmiş toplantılar (salt-okuma) sunucu-durumu (044). */
export function useArchivedMeetings(page: number, size: number, sort?: string) {
  return useQuery({
    queryKey: ['archived-meetings', page, size, sort ?? ''],
    queryFn: () => getArchivedMeetings({ page, size, sort }),
  })
}
